module.exports = __webpack_public_path__ + "img/presentation_materials.4d86f56c.png";